import React, { useEffect, useRef } from 'react'
import { IonHeader, IonToolbar, IonContent, IonAccordionGroup, IonAccordion, IonItem, IonLabel, IonList, IonFooter } from '@ionic/react'
import { useForm } from 'react-hook-form'
import SVG from '../components/SVG'

const Filters = ({ handleDismiss, data, incomingData, incomingSort, submitForm, amt, loading }) => {
  const { register, getValues, setValue, reset } = useForm()
  const accordionGroup = useRef(null)

  useEffect(() => {
    for (const key in incomingData) {
      setValue(key, incomingData[key])
    }
    if (incomingSort?.price) {
      setValue('sort-by', incomingSort.price === 'asc' ? 'PASC' : 'PDESC')
    } else if (incomingSort?.avg_rating) {
      setValue('sort-by', incomingSort.avg_rating === 'asc' ? 'RASC' : 'RDESC')
    } else {
      setValue('sort-by', 'default')
    }
  }, [])

  const onFormChange = (e) => {
    const filters = getValues()
    let sort = {}
    switch (filters['sort-by']) {
      case 'default':
        sort = {}
        break
      case 'PASC':
        sort = { price: 'asc' }
        break
      case 'PDESC':
        sort = { price: 'desc' }
        break
      case 'RASC':
        sort = { avg_rating: 'asc' }
        break
      case 'RDESC':
        sort = { avg_rating: 'desc' }
        break
      default:
        sort = {}
    }
    delete filters['sort-by']
    for (const key in filters) {
      if (!filters[key] || !filters[key].length) {
        delete filters[key]
      }
      if (typeof filters[key] === 'string') {
        filters[key] = [filters[key]]
      }
    }
    if (filters.on_hand_qty) {
      delete filters.on_hand_qty
      const newFilters = { ...filters, on_hand_qty: ['[1 TO *]'] }
      submitForm(newFilters, sort)
    } else {
      submitForm(filters, sort)
    }
  }

  const onClearClick = () => {
    const categoryFilters = getValues('category')
    reset()
    setValue('sort-by', 'default')

    if (categoryFilters?.length) {
      submitForm({ category: categoryFilters }, {})
    } else {
      submitForm({}, {})
    }
  }

  const getAccordionItemName = (key) => {
    switch (key) {
      case 'in_store_only': case 'on_hand_qty':
        return 'Availability'
      case 'buy_in_store':
        return 'Buy in-store'
      case 'color_group_array':
        return 'Color Group'
      case 'color_array':
        return 'Color'
      default:
        return key.replaceAll('_', ' ')
    }
  }

  const renderFunc = () => {
    const filterCategories = []
    for (const key in data) {
      if (key !== 'in_store_only' && key !== 'buy_in_store' && key !== 'shipping_price' && key !== 'fulfillment' && key !== 'on_hand_qty' && data[key].length) {
        filterCategories.push(
          <IonAccordion value={key} key={key}>
            <IonItem slot='header'>
              <IonLabel>{getAccordionItemName(key)}</IonLabel>
            </IonItem>
            <IonList slot='content'>
              {data[key].map((name) => (
                <label className="checkbox-wrapper filters__item" htmlFor={`${key}-${name}`} key={`${key}-${name}`}>
                  <input {...register(key)} id={`${key}-${name}`} value={name} type="checkbox" />
                  <span className="checkbox-wrapper__check">
                    <SVG name='checkmark' label="checkbox" size="base" />
                  </span>
                  <span className="checkbox-wrapper__label-text">{name}</span>
                </label>
              ))}
            </IonList>
          </IonAccordion>
        )
      }
    }
    return filterCategories
  }

  return (
    <div className='filters'>
      <IonHeader>
        <IonToolbar>
          <div>
            <button className='' aria-label="Close filters" onClick={handleDismiss}>
              <SVG name="close" label="Close" size="base" />
            </button>
            <p>FILTERS</p>
            <button
              className="filters__clear"
              onClick={onClearClick}
            >CLEAR
            </button>
          </div>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonAccordionGroup ref={accordionGroup} class='filters__accordion-group' multiple={true}>
          <form onChange={onFormChange}>
            <IonAccordion value='sort-by'>
              <IonItem slot='header'>
                <IonLabel>Sort by: Select One</IonLabel>
              </IonItem>
              <IonList slot='content'>
                <label className="radio-wrapper filters__item" htmlFor='recommended'>
                  <input
                    {...register('sort-by')}
                    type="radio"
                    id="recommended"
                    value="default"
                    readOnly
                  />
                  <span className="radio-wrapper__dot">
                    <span className="radio-wrapper__dot__inner"></span>
                  </span>
                  <IonLabel className='radio-wrapper__label-text'>Recommended</IonLabel>
                </label>
                <label className="radio-wrapper filters__item" htmlFor='PASC'>
                  <input
                    {...register('sort-by')}
                    type="radio"
                    id="PASC"
                    value="PASC"
                    readOnly
                  />
                  <span className="radio-wrapper__dot">
                    <span className="radio-wrapper__dot__inner"></span>
                  </span>
                  <IonLabel className='radio-wrapper__label-text'>Price: Low to High</IonLabel>
                </label>
                <label className="radio-wrapper filters__item" htmlFor='PDESC'>
                  <input
                    {...register('sort-by')}
                    type="radio"
                    id="PDESC"
                    value="PDESC"
                    readOnly
                  />
                  <span className="radio-wrapper__dot">
                    <span className="radio-wrapper__dot__inner"></span>
                  </span>
                  <IonLabel className="radio-wrapper__label-text">Price: High to Low</IonLabel>
                </label>
                <label className="radio-wrapper filters__item" htmlFor='RASC'>
                  <input
                    {...register('sort-by')}
                    type="radio"
                    id="RASC"
                    value="RASC"
                    readOnly
                  />
                  <span className="radio-wrapper__dot">
                    <span className="radio-wrapper__dot__inner"></span>
                  </span>
                  <IonLabel className='radio-wrapper__label-text'>Review: Low to High</IonLabel>
                </label>
                <label className="radio-wrapper filters__item" htmlFor='RDESC'>
                  <input
                    {...register('sort-by')}
                    type="radio"
                    id="RDESC"
                    value="RDESC"
                    readOnly
                  />
                  <span className="radio-wrapper__dot">
                    <span className="radio-wrapper__dot__inner"></span>
                  </span>
                  <IonLabel className='radio-wrapper__label-text'>Review: High to Low</IonLabel>
                </label>
              </IonList>
            </IonAccordion>
              <IonAccordion value='availability'>
                <IonItem slot='header'>
                  <IonLabel>Availability</IonLabel>
                </IonItem>
                <IonList slot='content'>
                  <label className='checkbox-wrapper filters__item'>
                    <input
                      {...register('in_store_only')}
                      value='false'
                      type="checkbox"
                      id="in-store-pickup"
                      disabled={!data.in_store_only?.includes('false')}
                    />
                    <span className="checkbox-wrapper__check">
                      <SVG name='checkmark' label="checkbox" size="base" />
                    </span>
                    <span className="checkbox-wrapper__label-text">In-Store Pickup</span>
                  </label>
                  <label className='checkbox-wrapper filters__item'>
                    <input
                      {...register('in_store_only')}
                      value='true'
                      type="checkbox"
                      id="in-store"
                      disabled={!data.in_store_only?.includes('true')}
                    />
                    <span className="checkbox-wrapper__check">
                      <SVG name='checkmark' label="checkbox" size="base" />
                    </span>
                    <span className="checkbox-wrapper__label-text">Exclusively available in-store</span>
                  </label>
                  <label className='checkbox-wrapper filters__item'>
                    <input
                      {...register('on_hand_qty')}
                      value='1 TO *'
                      type="checkbox"
                      id="in-stock-only"
                      disabled={!data.on_hand_qty?.some((val) => val !== '0.00')}
                    />
                    <span className="checkbox-wrapper__check">
                      <SVG name='checkmark' label="checkbox" size="base" />
                    </span>
                    <span className="checkbox-wrapper__label-text">In stock only</span>
                  </label>
                </IonList>
              </IonAccordion>
            {renderFunc()}
          </form>
        </IonAccordionGroup>
      </IonContent>
      <IonFooter>
        <div>
          <button
            className={`btn__primary btn__primary--full${loading ? ' btn__animated' : ''
              }`}
            onClick={handleDismiss}
          >
            VIEW {amt} {amt === 1 ? 'RESULT' : 'RESULTS'}
          </button>
        </div>
      </IonFooter>

    </div>
  )
}

export default Filters
